import React from 'react';

const ProfilePage = () => {
  return (
    <div className="pl-4 pt-8 md:p-8">
      <h1 className="text-3xl font-bold mb-4">Profile</h1>
    </div>
  );
};

export default ProfilePage;
